import { useEffect, useState } from "react";
// aos
import AOS from "aos";
import "aos/dist/aos.css";
import Layout from "../Layout/Layout";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { registerDonate } from "../../states/actions/donateAction";
import { useNavigate } from "react-router-dom";

const Payment = () => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 3000 });
  }, []);
  const donate = useSelector((state) => state.donate);
  const [selectedType, setSelectedType] = useState("oneTime");

  const isSelected = (type) => selectedType === type;

  const onSubmit = (Data) => {
    const sentData = {
      amount: Data?.amount,
      fname: Data?.fname,
      lname: Data?.lname,
      phone_number: Data?.phone,
      title: "Payment",
      email: Data?.email,
      address: Data?.address,
    };

    // dispatch
    dispatch(registerDonate(sentData));
    reset();
  };

  if (donate?.donate?.success === true) {
    const orderData = donate?.donate?.newOrder;
    // First, redirect to the callback URL
    window.location.replace(`${donate?.donate?.newOrder?.callback_url}`);
  }

  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleJoinSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // Pass email using React Router state
      navigate("/contact", { state: { email } });
    }
  };

  return (
    <Layout
      title="Aderaw Payment Page | Aderaw Addisu Law Office"
      description="Legal services in Bahir Dar including arbitration, litigation, contracts and consultation."
      keywords="Legal services Bahir Dar, Lawyer Ethiopia"
    >
      <section className="pt-12">
        <div
          class="w-full bg-center bg-cover h-[38rem]"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80')`,
          }}
        >
          <div class="flex items-center justify-center w-full h-full bg-gray-900/40">
            <div class="text-center">
              <h1 class="text-3xl font-semibold text-white lg:text-4xl">
                <span class="text-blue-400">Pay Now</span>{" "}
              </h1>
            </div>
          </div>
        </div>
        <section class="bg-white dark:bg-gray-900">
          <div class="flex justify-center min-h-screen">
            <div
              class="hidden bg-cover lg:block lg:w-2/5"
              style={{
                backgroundImage: `url('https://img.freepik.com/premium-vector/donation-box-donate-giving-money-vector-illustration-flat-style-design_622933-170.jpg')`,
              }}
            ></div>

            <div class="flex items-center w-full max-w-3xl p-8 mx-auto lg:px-12 lg:w-3/5">
              <div class="w-full">
                <h1 class="text-2xl font-semibold tracking-wider text-gray-800 capitalize dark:text-white">
                  Make a Donation
                </h1>

                <p class="mt-4 text-gray-500 dark:text-gray-400">
                  Let’s get you all set up so you can verify your personal
                  account and begin setting up your profile.
                </p>

                <div className="mt-6">
                  <h1 className="text-gray-500 dark:text-gray-300">
                    Select donation type
                  </h1>

                  <div className="mt-3 md:flex md:items-center md:-mx-2">
                    {/* One Time Button */}
                    <button
                      onClick={() => setSelectedType("oneTime")}
                      className={`flex justify-center w-full px-6 py-3 rounded-lg md:w-auto md:mx-2 focus:outline-none 
            ${
              isSelected("oneTime")
                ? "bg-blue-500 text-white"
                : "text-blue-500 border border-blue-500 dark:border-blue-400 dark:text-blue-400"
            }
          `}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                      <span className="mx-2">One Time</span>
                    </button>

                    {/* Monthly Button */}
                    <button
                      onClick={() => setSelectedType("monthly")}
                      className={`flex justify-center w-full px-6 py-3 mt-4 rounded-lg md:mt-0 md:w-auto md:mx-2 focus:outline-none 
            ${
              isSelected("monthly")
                ? "bg-blue-500 text-white"
                : "text-blue-500 border border-blue-500 dark:border-blue-400 dark:text-blue-400"
            }
          `}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 8c-1.657 0-3 1.343-3 3s1.343 3 3 3m0-6V4m0 10v4m0-4c1.657 0 3-1.343 3-3s-1.343-3-3-3"
                        />
                      </svg>

                      <span className="mx-2">Monthly</span>
                    </button>
                  </div>
                </div>

                <form
                  onSubmit={handleSubmit(onSubmit)}
                  class="grid grid-cols-1 gap-6 mt-8 md:grid-cols-2"
                >
                  <div>
                    <label class="block mb-2 text-sm text-gray-600 dark:text-gray-200">
                      First Name
                    </label>
                    <input
                      type="text"
                      placeholder="Gedefaye"
                      class="block w-full px-5 py-3 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-lg dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40"
                      {...register(`fname`, {
                        required: true,
                      })}
                    />
                  </div>

                  <div>
                    <label class="block mb-2 text-sm text-gray-600 dark:text-gray-200">
                      Last name
                    </label>
                    <input
                      type="text"
                      placeholder="Mengist"
                      class="block w-full px-5 py-3 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-lg dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40"
                      {...register(`lname`, {
                        required: true,
                      })}
                    />
                  </div>

                  <div>
                    <label class="block mb-2 text-sm text-gray-600 dark:text-gray-200">
                      Phone number
                    </label>
                    <input
                      type="text"
                      placeholder="XXX-XX-XXXX-XXX"
                      class="block w-full px-5 py-3 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-lg dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40"
                      {...register(`phone`, {
                        required: true,
                      })}
                    />
                  </div>

                  <div>
                    <label class="block mb-2 text-sm text-gray-600 dark:text-gray-200">
                      Email address
                    </label>
                    <input
                      type="email"
                      placeholder="gedefaye@example.com"
                      class="block w-full px-5 py-3 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-lg dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40"
                      {...register(`email`, {
                        required: true,
                      })}
                    />
                  </div>

                  <div>
                    <label class="block mb-2 text-sm text-gray-600 dark:text-gray-200">
                      Address
                    </label>
                    <input
                      type="text"
                      placeholder="Enter your address"
                      class="block w-full px-5 py-3 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-lg dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40"
                      {...register(`address`, {
                        required: true,
                      })}
                    />
                  </div>

                  <div>
                    <label class="block mb-2 text-sm text-gray-600 dark:text-gray-200">
                      Amount
                    </label>
                    <input
                      type="text"
                      placeholder="Enter custom amount"
                      class="block w-full px-5 py-3 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-lg dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40"
                      {...register(`amount`, {
                        required: true,
                      })}
                    />
                  </div>

                  <button
                    type="submit"
                    class="flex items-center justify-between w-full px-6 py-3 text-sm tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-lg hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
                  >
                    <span>Payment </span>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-5 h-5 rtl:-scale-x-100"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
        <section class="bg-white dark:bg-gray-900">
          <div class="container flex flex-col px-6 py-10 mx-auto space-y-6 lg:h-[32rem] lg:py-16 lg:flex-row lg:items-center">
            <div class="w-full lg:w-1/2">
              <div class="lg:max-w-lg">
                <h1 class="text-3xl font-semibold tracking-wide text-gray-800 dark:text-white lg:text-4xl">
                  Easiest ways to donate to Born to Win are
                </h1>

                <div class="mt-8 space-y-5">
                  <p class="flex items-center -mx-2 text-gray-700 dark:text-gray-200">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-6 h-6 mx-2 text-blue-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>

                    <span class="mx-2">Call directly via our office phone</span>
                  </p>

                  <p class="flex items-center -mx-2 text-gray-700 dark:text-gray-200">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-6 h-6 mx-2 text-blue-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>

                    <span class="mx-2">Contact us on WhatsApp</span>
                  </p>

                  <p class="flex items-center -mx-2 text-gray-700 dark:text-gray-200">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-6 h-6 mx-2 text-blue-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>

                    <span class="mx-2">Send an email</span>
                  </p>
                </div>
              </div>

              <div class="w-full mt-8 bg-transparent border rounded-md lg:max-w-sm dark:border-gray-700 focus-within:border-blue-400 focus-within:ring focus-within:ring-blue-300 dark:focus-within:border-blue-400 focus-within:ring-opacity-40">
                <form
                  class="flex flex-col lg:flex-row"
                  onSubmit={handleJoinSubmit}
                >
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    class="flex-1 h-10 px-4 py-2 m-1 text-gray-700 placeholder-gray-400 bg-transparent border-none appearance-none dark:text-gray-200 focus:outline-none focus:placeholder-transparent focus:ring-0"
                  />

                  <button
                    type="submit"
                    class="h-10 px-4 py-2 m-1 text-white transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-400 focus:outline-none focus:bg-blue-400"
                  >
                    Join Us
                  </button>
                </form>
              </div>
            </div>
            <div class="flex items-center justify-center w-full h-96 lg:w-1/2">
              <img
                class="object-cover w-full h-full mx-auto rounded-md lg:max-w-2xl"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0WePGa4cunUZ40A0HOxcRfAyteC_6C1thtg&s"
                alt="glasses photo"
              />
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};
export default Payment;
